<template>
    <main>

        <div class="row">
            <div class="col-md-6">
                <div class="titles">
                    <h2 class="uppercase"><b><i class="fa fa-briefcase"></i> Configure os cargos</b></h2>
                </div>
            </div>
            <div class="col-sm-6">
                <button class="btn-large-40 btn-success uppercase pull-right" @click="openCreate()">
                    Criar
                </button>
            </div>

            <div class="col-sm-12">

                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Cargo</th>
                                <th class="text-center" width="200"><i class="fa fa-cog"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                <td>{{ item.cargo.nmCargo }}</td>
                                <td class="text-center">
                                    <button type="button" class="btn btn-sm btn-success" v-b-tooltip title="Configurar Conceitos" @click="openCargo(item)">
                                        Conceitos
                                    </button>
                                    <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Remover" @click="openRemove(item)">
                                        <i class="fa fa-trash-o"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered size="lg" v-model="dialogCargo" :hide-footer="true" title="Configurar conceitos">
            <avaliacao-cargo-conceito v-if="dialogCargo" :avaliacao-id="avaliacaoId" :cargo-id="cargoId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Adicionar Cargo">
            <form-create :avaliacao-id="avaliacaoId" v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import avaliacaoCargoConceito from './avaliacaocargoconceito'
    
    export default {
        name: 'avaliacaocargo',
        mixins: [base],
        props: { avaliacaoId: Number },
        components: { formCreate, avaliacaoCargoConceito },
        data() {
            return {

                resources: {
                    filter: 'avaliacaocargo',
                    remove: 'avaliacaocargo'
                },

                dialogCargo: false,
                dialogRemove: false,
                dialogCreate: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openCargo: function (model) {
                this.avaliacaoId = model.avaliacaoId;
                this.cargoId = model.cargoId;
                this.dialogCargo = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogRemove = false;
                this.dialogCargo = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                this.filter.avaliacaoId = this.avaliacaoId;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>